import React, { useState, useEffect } from 'react';
import { Result, Spin } from 'antd';
import { getMenus } from '../services/api';
import { getUser } from '../utils/auth';

const pageCodeMap = {
  '/system/users': 'system:users',
  '/system/roles': 'system:roles',
  '/system/logs': 'system:logs',
  '/marketing/basic': 'marketing:basic',
  '/marketing/yearly-target': 'marketing:yearly-target',
  '/marketing/tasks': 'marketing:tasks',
  '/marketing/performance': 'marketing:performance',
  '/marketing/reports': 'marketing:reports',
  '/sales/orders': 'sales:orders',
  '/purchase/cost': 'purchase:cost',
  '/dashboard/bi': 'dashboard',
};

let menusCache = null;
let menusCacheRole = null;

export default function AuthGuard({ path, children }) {
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    const requiredCode = pageCodeMap[path];
    if (!requiredCode) {
      setStatus('allowed');
      return;
    }

    const user = getUser();
    if (user?.roleName === '超级管理员') {
      setStatus('allowed');
      return;
    }

    const checkAccess = (pages) => {
      setStatus(findCode(pages, requiredCode) ? 'allowed' : 'denied');
    };

    const currentRole = user?.roleName || '';
    if (menusCache && menusCacheRole === currentRole) {
      checkAccess(menusCache);
      return;
    }

    getMenus().then(res => {
      const pages = res.data || [];
      menusCache = pages;
      menusCacheRole = currentRole;
      checkAccess(pages);
    }).catch(() => {
      setStatus('denied');
    });
  }, [path]);

  if (status === 'loading') {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}><Spin size="large" /></div>;
  }

  if (status === 'denied') {
    return <Result status="403" title="403" subTitle="抱歉，您没有权限访问此页面" />;
  }

  return children;
}

function findCode(pages, targetCode) {
  for (const p of pages) {
    if (p.code === targetCode || p.path === targetCode) return true;
    if (p.children && p.children.length > 0) {
      if (findCode(p.children, targetCode)) return true;
    }
  }
  return false;
}
